import { cn } from '@/lib/utils'
import type { ProgressBarProps } from './types'

export function ProgressBar({
	currentStep,
	totalSteps = 3,
	isGenerating = false,
	generationStep = 0,
}: ProgressBarProps) {
	return (
		<div className="flex gap-1.5">
			{Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => {
				let colorClass: string

				if (isGenerating) {
					if (step < generationStep) {
						colorClass = 'bg-primary'
					} else if (step === generationStep) {
						colorClass = 'bg-primary/50'
					} else {
						colorClass = 'bg-muted'
					}
				} else {
					colorClass = step <= currentStep ? 'bg-primary' : 'bg-muted'
				}

				return (
					<div
						key={step}
						className={cn('flex-1 h-1 rounded-full transition-all duration-300', colorClass)}
					/>
				)
			})}
		</div>
	)
}
